/**
 * Designer Appliances - Header Mega Menu Interactions
 */
document.addEventListener('DOMContentLoaded', () => {
  // 1. Subcategory Tab Switcher (Kitchen / Laundry)
  document.querySelectorAll('.da-subnav-tab').forEach((tab) => {
    tab.addEventListener('mouseenter', function () {
      switchSubnavTab(this);
    });
    tab.addEventListener('click', function () {
      switchSubnavTab(this);
    });
  });

  function switchSubnavTab(tab) {
    const tabName = tab.getAttribute('data-tab');
    const container = tab.closest('.da-dropdown-container');
    if (!container || !tabName) return;

    // Set active tab button
    container.querySelectorAll('.da-subnav-tab').forEach((t) => t.classList.remove('active'));
    tab.classList.add('active');

    // Show corresponding tab panel
    container.querySelectorAll('.da-tab-panel').forEach((panel) => panel.classList.remove('active'));
    const targetPanel = container.querySelector(`#da-tab-${tabName}`);
    if (targetPanel) {
      targetPanel.classList.add('active');
    }
  }

  // 2. Subnav Bar & Content Hover Handling (Reveal panel when moving cursor to subnav-bar)
  document.querySelectorAll('.da-dropdown-container').forEach((container) => {
    const subnavBar = container.querySelector('.da-subnav-bar');
    const contentWrap = container.querySelector('.da-subnav-content-wrap');

    if (subnavBar) {
      subnavBar.addEventListener('mouseenter', () => {
        container.classList.add('is-subnav-open');
      });
    }
    if (contentWrap) {
      contentWrap.addEventListener('mouseenter', () => {
        container.classList.add('is-subnav-open');
      });
    }
  });

  // 3. Alphabet Filter Tab Switcher (By Brand)
  document.querySelectorAll('.da-alpha-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      const alphaKey = this.getAttribute('data-alpha');
      const container = this.closest('.da-menu-col--all-brands');
      if (!container || !alphaKey) return;

      container.querySelectorAll('.da-alpha-btn').forEach((b) => b.classList.remove('active'));
      this.classList.add('active');

      container.querySelectorAll('.da-alpha-panel').forEach((p) => p.classList.remove('active'));
      const targetPanel = container.querySelector(`#da-alpha-${alphaKey}`);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
    });
  });

  // 4. Desktop Hover Intent & Switch Debounce handling
  const navItems = document.querySelectorAll('.da-nav-item--has-dropdown');
  let currentOpenItem = null;
  let enterTimeout = null;
  let leaveTimeout = null;

  const closeAllExcept = (activeItem) => {
    navItems.forEach((other) => {
      if (other !== activeItem) {
        other.classList.remove('is-open');
        const otherContainer = other.querySelector('.da-dropdown-container');
        if (otherContainer) {
          otherContainer.classList.remove('is-subnav-open');
        }
      }
    });
  };

  const activateItem = (item) => {
    if (leaveTimeout) {
      clearTimeout(leaveTimeout);
      leaveTimeout = null;
    }
    if (enterTimeout) {
      clearTimeout(enterTimeout);
      enterTimeout = null;
    }
    closeAllExcept(item);
    item.classList.add('is-open');
    currentOpenItem = item;
  };

  const scheduleDeactivate = () => {
    if (enterTimeout) {
      clearTimeout(enterTimeout);
      enterTimeout = null;
    }
    if (leaveTimeout) clearTimeout(leaveTimeout);
    leaveTimeout = setTimeout(() => {
      closeAllExcept(null);
      navItems.forEach((it) => {
        const c = it.querySelector('.da-dropdown-container');
        if (c) resetSubnavTabs(c);
      });
      currentOpenItem = null;
    }, 240);
  };

  const isPopupOpen = () => {
    return Array.from(popupDetailsList).some((d) => /** @type {HTMLDetailsElement} */ (d).open);
  };

  navItems.forEach((item) => {
    const container = item.querySelector('.da-dropdown-container');

    item.addEventListener('mouseenter', () => {
      // If popup menu (Shop by Categories) is currently open, disable hover dropdowns
      if (isPopupOpen()) return;

      if (leaveTimeout) {
        clearTimeout(leaveTimeout);
        leaveTimeout = null;
      }

      // If this item is already open, keep it open
      if (currentOpenItem === item) return;

      // If another dropdown is already open, wait 260ms (Hover Intent)
      // This prevents accidental switches when moving cursor downwards across the 2nd line!
      if (currentOpenItem && currentOpenItem !== item) {
        if (enterTimeout) clearTimeout(enterTimeout);
        enterTimeout = setTimeout(() => {
          activateItem(item);
        }, 260);
      } else {
        // If no menu is open, open immediately
        activateItem(item);
      }
    });

    /** @param {MouseEvent} e */
    item.addEventListener('mouseleave', (e) => {
      // If moving to another element inside this same nav item or its dropdown, ignore!
      const toElement = e.relatedTarget;
      if (toElement && toElement instanceof Node && item.contains(toElement)) {
        return;
      }
      if (enterTimeout) {
        clearTimeout(enterTimeout);
        enterTimeout = null;
      }
      scheduleDeactivate();
    });

    if (container) {
      container.addEventListener('mouseenter', () => {
        // As soon as cursor reaches dropdown content, cancel any pending switch to other items!
        if (enterTimeout) {
          clearTimeout(enterTimeout);
          enterTimeout = null;
        }
        if (leaveTimeout) {
          clearTimeout(leaveTimeout);
          leaveTimeout = null;
        }
      });
    }
  });

  function resetSubnavTabs(container) {
    const tabs = container.querySelectorAll('.da-subnav-tab');
    const panels = container.querySelectorAll('.da-tab-panel');
    if (tabs.length > 0) {
      tabs.forEach((t, i) => {
        if (i === 0) t.classList.add('active');
        else t.classList.remove('active');
      });
    }
    if (panels.length > 0) {
      panels.forEach((p, i) => {
        if (i === 0) p.classList.add('active');
        else p.classList.remove('active');
      });
    }
  }

  // 5. Popup Mega Menu (BHL style)
  const listDetailsElem = document.querySelectorAll('.mega-menu.details > summary');
  const listContentsElem = document.querySelectorAll('.mega-menu__content');
  const SublistDetailsElem = document.querySelectorAll('.mega-menu__item.details > summary');
  const SublistContentsElem = document.querySelectorAll('.mega-menu__item .mega-menu__content');
  const popupDetailsList = document.querySelectorAll('.main-menu-item details');

  popupDetailsList.forEach((item) => {
    item.addEventListener('toggle', function () {
      if (this.open) {
        // Close any hover mega menus immediately when popup is opened
        if (enterTimeout) clearTimeout(enterTimeout);
        if (leaveTimeout) clearTimeout(leaveTimeout);
        closeAllExcept(null);
        navItems.forEach((it) => {
          const c = it.querySelector('.da-dropdown-container');
          if (c) resetSubnavTabs(c);
        });
        currentOpenItem = null;
      } else {
        listContentsElem.forEach((el) => {
          el.classList.remove('menu-opening');
          if (el.parentElement) el.parentElement.classList.remove('menu-opening');
        });
        SublistContentsElem.forEach((el) => {
          el.classList.remove('menu-opening');
          if (el.parentElement) el.parentElement.classList.remove('menu-opening');
        });
      }
    });
  });

  listDetailsElem.forEach((item) => {
    item.addEventListener('click', function () {
      listContentsElem.forEach((el) => {
        el.classList.remove('menu-opening');
        if (el.parentElement) el.parentElement.classList.remove('menu-opening');
      });

      const content = this.nextElementSibling;
      if (content) {
        content.classList.toggle('menu-opening');
      }
      if (this.parentElement) {
        this.parentElement.classList.add('menu-opening');
      }
    });
  });

  SublistDetailsElem.forEach((item) => {
    item.addEventListener('click', function () {
      SublistContentsElem.forEach((el) => {
        el.classList.remove('menu-opening');
        if (el.parentElement) el.parentElement.classList.remove('menu-opening');
      });

      const content = this.nextElementSibling;
      if (content) {
        content.classList.toggle('menu-opening');
      }
      if (this.parentElement) {
        this.parentElement.classList.add('menu-opening');
      }
    });
  });

  const myElement = document.querySelector('.main-menu, .da-nav-list');
  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    const target = event.target;
    if (!(target instanceof Node)) return;

    if (myElement && !myElement.contains(target)) {
      if (enterTimeout) clearTimeout(enterTimeout);
      if (leaveTimeout) clearTimeout(leaveTimeout);
      closeAllExcept(null);
      currentOpenItem = null;

      listContentsElem.forEach((el) => {
        el.classList.remove('menu-opening');
        if (el.parentElement) el.parentElement.classList.remove('menu-opening');
      });
      SublistContentsElem.forEach((el) => {
        el.classList.remove('menu-opening');
        if (el.parentElement) el.parentElement.classList.remove('menu-opening');
      });
    }

    popupDetailsList.forEach((details) => {
      const detailsEl = /** @type {HTMLDetailsElement} */ (details);
      const isOverlay = target instanceof Element && target.classList.contains('menu-overlay');
      if (detailsEl.open && (!detailsEl.contains(target) || isOverlay)) {
        detailsEl.removeAttribute('open');
      }
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      popupDetailsList.forEach((details) => {
        details.removeAttribute('open');
      });
      listContentsElem.forEach((el) => {
        el.classList.remove('menu-opening');
        if (el.parentElement) el.parentElement.classList.remove('menu-opening');
      });
      SublistContentsElem.forEach((el) => {
        el.classList.remove('menu-opening');
        if (el.parentElement) el.parentElement.classList.remove('menu-opening');
      });
    }
  });
});

